import { TableCell, Tooltip } from '@mui/material';
import React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import IconWrapper from './styles/IconWrapper';

type DeleteButtonProps = {
  onClick: () => void;
};

function DeleteButton({ onClick }: DeleteButtonProps): JSX.Element {
  return (
    <TableCell onClick={onClick}>
      <Tooltip title="Удалить" arrow placement="right">
        <IconWrapper>
          <CloseIcon />
        </IconWrapper>
      </Tooltip>
    </TableCell>
  );
}

export default DeleteButton;
